'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { IResortPageInfo } from '@/api/resort/types';
import { RouteAndAnalyticsProps } from '@/page-components/pathTypes';
import { IResortLayout } from '@/page-components/resort/_layout';
import { Routes } from '@/routes';
import WeSkiPage from '@/components/common/PlanYourTrip/WeSki/WeSkiPage';
import { getLocale } from '@/i18n/locale';
import { isResortWithoutWeSki } from '@/util/isResortWithoutWeSki';

export type ResortBookTripProps = {
  resort: IResortPageInfo,
  destinationId: string,
} & RouteAndAnalyticsProps & IResortLayout;

export const DEBUG_TAG = 'resort-book-trip-page';
export const TEMPLATE_ID = '3.2.9';
export const TEMPLATE_NAME = 'Resort Book Trip';

export default function ResortBookTrip({ resort, destinationId, pathInfo }: ResortBookTripProps) {
  const router = useRouter();
  const locale = getLocale();
  const shouldHideWeSki = isResortWithoutWeSki(resort.uuid, locale);
  const redirectUrl = Routes.resortTripPlanningOverview(pathInfo);

  useEffect(() => {
    if (shouldHideWeSki) {
      router.replace(redirectUrl);
    }
  }, [redirectUrl, router, shouldHideWeSki]);

  if (shouldHideWeSki) {
    return null;
  }

  return (
    <WeSkiPage
      destinationId={destinationId}
      focusImage={resort?.image}
    />
  );
}

// fetchProps moved to ./book-trip.server.ts so the App Router RSC page can
// import the data fetcher without pulling in this 'use client' bundle.
